// extracted by mini-css-extract-plugin
export default {"FooterBar__icon":"icons_FooterBar__icon__hPGgA","active":"icons_active__dnqqR","FooterBar__icon--home":"icons_FooterBar__icon--home__B8EKo"};